import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientLogService {
  private http: HttpClient;
  private baseUrl = environment.baseUrl;

  constructor(handler: HttpBackend, private authService: AuthService) {
    // Use HttpBackend to avoid interceptors and prevent recursion.
    this.http = new HttpClient(handler);
  }

  log(level: 'ERROR' | 'WARNING' | 'INFO', message: string, stack?: string, context?: any) {
    const token = this.authService.getToken();
    if (!token) {
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    const payload = {
      level,
      message,
      stack: stack || '',
      url: window.location.href,
      user_agent: navigator.userAgent,
      context: context || {}
    };

    this.http.post(`${this.baseUrl}client-logs/`, payload, { headers }).subscribe({
      next: () => {},
      error: () => {}
    });
  }
}
